export default __webpack_public_path__ + "static/media/2078.c356e3d1.png";